import { useSyncExternalStore } from 'react'

// Source of truth for which meal-view design a tester is looking at. Persisted to
// localStorage so it survives navigation; an external store so the floating toggle
// and the BottomTabBar both re-render the moment it flips. Delete this file (and the
// three call sites) to remove the experiment entirely.
export type DesignVariant = 'v1' | 'v2'

const KEY = 'parsley.design.mealView'
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

function readVariant(): DesignVariant {
  if (typeof window === 'undefined') return 'v1'
  return window.localStorage.getItem(KEY) === 'v2' ? 'v2' : 'v1'
}

export function setDesignVariant(variant: DesignVariant) {
  window.localStorage.setItem(KEY, variant)
  emit()
}

function subscribe(callback: () => void) {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}

export function useDesignVariant(): DesignVariant {
  return useSyncExternalStore(subscribe, readVariant, () => 'v1')
}
